import { ISignupRequest, IGuestSignupRequest } from "@/app/globalContext/signup.interface";

const API_BASE_URL = process.env.NEXT_PUBLIC_HOME_BASE_API;

export const apiSignupService = {

	async signUp(requestData?: ISignupRequest) {
		const response = await fetch(`${API_BASE_URL}/signup`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'captcha-token': requestData?.recaptchaToken ?? '',
				'captcha-action': 'signup',
			},
			body: JSON.stringify(requestData),
		});

		if (!response.ok) {
			const errorData = await response.json();
			throw {
				status: response.status,
				message: errorData.message || 'Error en el registro',
				data: errorData
			};
		}
		return await response.json();
	},

	async signUpGuest(requestData?: IGuestSignupRequest) {
		const response = await fetch(`${API_BASE_URL}/signup/guest`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'captcha-token': requestData?.recaptchaToken ?? '',
				'captcha-action': 'signup_guest',
			},
			body: JSON.stringify(requestData),
		});

		if (!response.ok) {
			const errorData = await response.json();
			throw {
				status: response.status,
				message: errorData.message || 'Error en el registro como invitado',
				data: errorData
			};
		}
		return await response.json();
	},
};
